import App from "app/App";
import { userRoutes } from "config/routes";
import Cookies from "js-cookie";
import React from "react";
// import * as Cookie from "js-cookie";
import { Redirect, Route, Switch } from "react-router-dom";

export const PrivateRoute = ({ ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      // const currentUser = authenticationService.currentUserValue;
      const token = Cookies.get("access_token");
      if (!token) {
        return (
          <Redirect
            to={{
              pathname: `/login`,
              state: { from: props.location },
            }}
          />
        );
      }
      return (
        <React.Suspense fallback={null}>
          <App>
            <Switch>
              <Route
                exact
                path={`/`}
                render={() => {
                  return <Redirect to={`/landing-page`} />;
                }}
              />
              {userRoutes.map(({ path, component: Component }) => (
                <Route
                  key={path}
                  path={path}
                  render={(props) => {
                    return <Component />;
                  }}
                ></Route>
              ))}
            </Switch>
          </App>
        </React.Suspense>
      );
    }}
  />
);
